import { render, staticRenderFns } from "./detrecomvideo.vue?vue&type=template&id=68fee379&"
import script from "./detrecomvideo.vue?vue&type=script&lang=js&"
export * from "./detrecomvideo.vue?vue&type=script&lang=js&"
import style0 from "./detrecomvideo.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports